<div *ngIf="!hidePaidTable" class="data-table">
<div class="data-table__head">
    <div class="grid-row grid-row--aic">
      <div class="grid-col">
        <h3>Previous</h3>
      </div>

      <div class="grid-col grid-col--auto">
        <select type="text" class="form-select" (change)=shownTimeSelectionChanged($event.target.value)>
          <option *ngFor="let selectedTimeframe of shownTimeSelectionOptions" data-cy="previous-time-options-dropdown">{{selectedTimeframe}}</option>
        </select>
      </div>
    </div>
  </div>


  <div class="data-table__cont">
    <table mat-table matSort matSortActive="date"
           [dataSource]="previousPaymentsService.dataSourcePreviousPayments"
           matSortDirection="desc" class="data-table__tbl">

      <!--Date-->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
        <td mat-cell *matCellDef="let paymentUi" data-cy="payment-transaction-date">
          {{paymentUi.payment.arTran.transactionDate | date: 'MM/dd/yy' }}
        </td>
      </ng-container>

      <!--Client (account)-->
      <ng-container matColumnDef="client">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Account</th>
        <td mat-cell *matCellDef="let paymentUi" data-cy="payment-client-name">
          {{paymentUi.client.name}}
        </td>
      </ng-container>

      <!--Method-->
      <ng-container matColumnDef="method">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Method</th>
        <td mat-cell *matCellDef="let paymentUi" class="tt--capitalize" data-cy="payment-method">
                <div *ngIf="paymentUi.payment.last4 === null; then thenBlock else elseBlock"></div>
                <ng-template #thenBlock>
                  <div class="tc--dark">Unavailable</div>
                </ng-template>
                <ng-template #elseBlock>
                      <span *ngIf="isDirectDebit(paymentUi.payment.paymentMethod); else card"><img
                        src="assets/payment-methods/union.svg"
                        width="20" height="20" alt="" class="data-table__payment-icon">
                        {{ paymentUi.payment.paymentMethod | uppercase }} Bank Transfer ••••{{paymentUi.payment.last4}}
                      </span>
                  <ng-template #card>
                    <img
                      src="assets/payment-methods/{{paymentUi.payment.cardType}}.svg"
                       width="20" height="20" alt="" class="data-table__payment-icon">
                  {{paymentUi.payment.cardType}} ••••{{paymentUi.payment.last4}}
                  </ng-template>
                </ng-template>
        </td>
      </ng-container>

      <!--Amount-->
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
        <td mat-cell *matCellDef="let paymentUi" data-cy="payment-amount">
          {{ Math.abs(paymentUi.payment.amount) | currency : paymentUi.currency?.code }}
        </td>
      </ng-container>

      <!--Status-->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let paymentUi" data-cy="payment-status">
          <div *ngIf="paymentUi.payment.arTran.active">
            <div class="badge badge--warning" *ngIf="paymentUi.refundStatus === 'succeeded'">
              <div class="badge__label">
                Refunded
              </div>
            </div>

            <div class="badge badge--success" *ngIf="paymentUi.refundStatus === 'none' && paymentUi.disputeStatus === 'none'">
              <div class="badge__label">
                {{ 'Completed ' + (paymentUi.paymentSource ? (' (' + paymentUi.paymentSource + ')') : '') }}
              </div>
            </div>

            <div class="badge badge--warning" *ngIf="paymentUi.disputeStatus === 'LOST'">
              <div class="badge__label">
                Refunded via Dispute
              </div>

              <span class="px-2">
                {{ paymentUi.payment.failedFundsWithdrawnAt | date: 'MM/dd/yyyy' }}
              </span>
            </div>
          </div>

          <div *ngIf="!paymentUi.payment.arTran.active">
            <div class="badge badge--error">
              <div class="badge__label">
                Failed &nbsp;<svg width="12" height="20" viewBox="0 0 16 16" fill="currentColor" class="inline-icon"><path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S11.3,14,8,14z"></path><rect x="7" y="7" width="2" height="5"></rect><circle cx="8" cy="5" r="1"></circle></svg>
              </div>
            </div>
          </div>
        </td>
      </ng-container>

      <!--invoiceNumber-->
      <ng-container matColumnDef="invoiceNumber">
        <th mat-header-cell *matHeaderCellDef>Invoice</th>
        <td mat-cell *matCellDef="let paymentUi" data-cy="payment-invoiceNumber">
          @if (!paymentUi.invoices.length && !paymentUi.autoDraftEngagementIds?.length && !paymentUi.prePayments?.length) {
            <div class="tc--dark">- -</div>
          } @else {
            <expandable-invoice-list
              [invoices]="paymentUi.invoices"
              [maxItems]="4"
              (downloadInvoice)="downloadInvoiceAsPdf($event)"
              (previewInvoice)="previewInvoiceAsPdf($event)"
            ></expandable-invoice-list>
            <a
              *ngFor="let engagementId of paymentUi.autoDraftEngagementIds.concat(paymentUi.prePayments?.[0]?.engagement.id ?? [])"
              [routerLink]="['/', ROUTE_TOKEN_MAIN_BASE, ROUTE_TOKEN_ENGAGEMENTS_BASE, engagementId]"
              class="fw--500 text-link-no-underline text-link-hover-underline d-block"
            >
              Engagement {{ engagementId }}
            </a>
          }
        </td>
      </ng-container>

      <!-- May be used at a later time. Don't remove for now.-->
<!--      <ng-container matColumnDef="record">-->
<!--        <th mat-header-cell *matHeaderCellDef mat-sort-header>Payment Id</th>-->
<!--        <td mat-cell *matCellDef="let paymentUi">-->
<!--          {{paymentUi.payment.paymentPlatformId}}-->
<!--        </td>-->
<!--      </ng-container>-->

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="data-table__row"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay"
          class="data-table__row data-table__row--selectable"></tr>
    </table>
  </div>
  <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" [showFirstLastButtons]="true" class="legacy-layout"></mat-paginator>
</div>

<!--<div *ngIf="!hidePaidTable && configService.isMobile">-->
<!--  <div class="mt&#45;&#45;200 grid-row grid-row&#45;&#45;aic">-->
<!--    <div class="grid-col">-->
<!--      <h3>Previous</h3>-->
<!--    </div>-->

<!--    <div class="grid-col grid-col&#45;&#45;auto">-->
<!--      <button type="button" class="button button&#45;&#45;simple">-->
<!--&lt;!&ndash;              [disabled]="(invoiceService.selectedInvoicesPaid | checkForAttachment) == false"&ndash;&gt;-->
<!--&lt;!&ndash;              (click)="invoicePdfService.exportMultipleInvoicesAsPDFs(invoiceService.selectedInvoicesPaid)">&ndash;&gt;-->
<!--        <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"-->
<!--             stroke-linecap="round" stroke-linejoin="round" class="button__icon">-->
<!--          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>-->
<!--          <polyline points="7 10 12 15 17 10"></polyline>-->
<!--          <line x1="12" y1="15" x2="12" y2="3"></line>-->
<!--        </svg>-->
<!--&lt;!&ndash;        <span>Export {{invoiceService.selectedInvoicesPaid | filterAttachments}} Invoices</span>&ndash;&gt;-->
<!--      </button>-->
<!--    </div>-->
<!--  </div>-->

<!--  <div class="mt&#45;&#45;075" *ngFor="let invoiceTableDataObject of invoiceService.dataSourcePaid.data;">-->
<!--    <app-invoice-table-card [invoiceTableDataObject]="invoiceTableDataObject"></app-invoice-table-card>-->
<!--  </div>-->
<!--</div>-->


<div *ngIf="hidePaidTable" class="mt--100 block ta--center">
  <h3 class="mt--250">You don't have any previous payments yet</h3>
  <div class="p mt--050 mb--250">Payments made for invoices and recurring payments will show up here when you do.</div>
</div>
